import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const PointsDisplay = ({ points, color = "#00BE95" }) => {
  return (
    <div>
      <AnimatePresence mode="wait">
        <motion.div
          key={points}
          initial={{ opacity: 0, scale: 0.8, y: -20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className={`text-[20px] font-[500]`}
        >
          <span style={{ color: `${color}` }}>{points}</span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default PointsDisplay;
